// extracted by mini-css-extract-plugin
export default {"titleContainer":"ContentContainerTitle_titleContainer__OfpLH","indicatorName":"ContentContainerTitle_indicatorName__y6bXh","targetName":"ContentContainerTitle_targetName__ZOUB5"};